import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, ShoppingCart } from 'lucide-react';
import { StripeService } from '@/services/stripe.service';

interface CartItem {
    photoId: string;
    quantity: number;
    unitPrice: number;
    data?: any; // Dados do evento e foto vindos do carrinho
}

interface CheckoutButtonProps {
    cartItems: CartItem[];
    userId: string;
    successUrl: string;
    cancelUrl: string;
    onSuccess?: (sessionId: string, orderId: string) => void;
    onError?: (error: string) => void;
    className?: string;
    children?: React.ReactNode;
}

export function CheckoutButton({
    cartItems,
    userId,
    successUrl,
    cancelUrl,
    onSuccess,
    onError,
    className,
    children,
}: CheckoutButtonProps) {
    const [isLoading, setIsLoading] = useState(false);

    const handleCheckout = async () => {
        try {
            setIsLoading(true);

            const result = await StripeService.processCheckout({
                cartItems,
                userId,
                successUrl,
                cancelUrl,
            });

            if (result.success) {
                onSuccess?.(result.sessionId, result.orderId);
            }
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
            onError?.(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const getTotalAmount = () => {
        return cartItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0);
    };

    return (
        <Button
            onClick={handleCheckout}
            disabled={isLoading || cartItems.length === 0}
            className={className}
            size="lg"
        >
            {isLoading ? (
                <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Processando...
                </>
            ) : (
                <>
                    <ShoppingCart className="mr-2 h-4 w-4" />
                    {children || `Finalizar Compra - R$ ${getTotalAmount().toFixed(2)}`}
                </>
            )}
        </Button>
    );
}
